import { ConfirmationModal as ConfirmationModalLib } from "@sw-sw/lib-ui";

export const ConfirmationModal = ConfirmationModalLib;

export default ConfirmationModal;
